<script>
import ModalBus from '@/eventBus'

export default {
  props: {
    submission: Object,
  },

  data() {
    return {
      title: this.submission.type_name,
    }
  },

  methods: {
    closePopup() {
      ModalBus.emit('close')
    },
  },
}
</script>

<template>
  <div class="w-11/12 rounded-xl bg-white">
    <div class="flex items-center justify-between border-b-2 border-light/25 p-5">
      <span class="max-w-10/12 font-poppins text-xl font-medium lg:text-secondary">
        {{ title }}
      </span>
      <button
        class="relative h-10 w-10 rounded-full bg-secondary focus:outline-none"
        @click="closePopup">
        <div
          class="absolute left-1/2 top-1/2 flex h-1/2 w-1/2 -translate-x-1/2 -translate-y-1/2 flex-col items-end justify-between">
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full rotate-45 rounded bg-white"></div>
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full -rotate-45 rounded bg-white"></div>
        </div>
      </button>
    </div>
    <div class="p-5">
      <div v-if="submission.type === $enums.SubmissionType.CONTACT">
        <p>{{ $t('account.submission.modal.contact.description') }}</p>
        <ul class="mt-3">
          <li>
            <strong>{{ $t('account.submission.modal.commons.lastname') }}</strong> {{ submission.lastname }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.firstname') }}</strong> {{ submission.firstname }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.email') }}</strong> {{ submission.email }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.phone') }}</strong> {{ submission.phone }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.country') }}</strong> {{ submission.country }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.contact.message') }}</strong> {{ submission.message }}
          </li>
        </ul>
      </div>
      <div v-else-if="submission.type === $enums.SubmissionType.REMINDER">
        <p>{{ $t('account.submission.modal.call.description') }}</p>
        <ul class="mt-3">
          <li>
            <strong>{{ $t('account.submission.modal.commons.lastname') }}</strong> {{ submission.lastname }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.firstname') }}</strong> {{ submission.firstname }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.email') }}</strong> {{ submission.email }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.phone') }}</strong> {{ submission.phone }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.country') }}</strong> {{ submission.country }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.call.reason') }}</strong>
            {{ submission.specific_fields.reason }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.call.call_date') }}</strong>
            {{ submission.specific_fields.call_date }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.call.call_hour') }}</strong>
            {{ submission.specific_fields.call_hour }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.call.start_at') }}</strong>
            {{ submission.start_date_format }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.call.end_at') }}</strong> {{ submission.end_date_format }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.call.message') }}</strong> {{ submission.message }}
          </li>
        </ul>
      </div>
      <div v-else-if="submission.type === $enums.SubmissionType.ACCOMMODATION">
        <p>{{ $t('account.submission.modal.quoteFormAccommodation.description') }}</p>
        <ul class="mt-3">
          <li>
            <strong>{{ $t('account.submission.modal.commons.lastname') }}</strong> {{ submission.lastname }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.firstname') }}</strong> {{ submission.firstname }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.email') }}</strong> {{ submission.email }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.phone') }}</strong> {{ submission.phone }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.country') }}</strong> {{ submission.country }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormAccommodation.start_at') }}</strong>
            {{ submission.start_date_format }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormAccommodation.end_at') }}</strong>
            {{ submission.end_date_format }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormAccommodation.accommodation') }}</strong
            >{{ submission.accommodation.title }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormAccommodation.adults') }}</strong>
            {{ submission.specific_fields.booking.adults }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormAccommodation.child') }}</strong>
            {{ submission.specific_fields.booking.child }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormAccommodation.babies') }}</strong>
            {{ submission.specific_fields.booking.babies }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormAccommodation.message') }}</strong>
            {{ submission.message }}
          </li>
        </ul>
      </div>
      <div v-else-if="submission.type === $enums.SubmissionType.VEHICLE">
        <p>{{ $t('account.submission.modal.quoteFormVehicle.description') }}</p>
        <ul class="mt-3">
          <li>
            <strong>{{ $t('account.submission.modal.commons.lastname') }}</strong> {{ submission.lastname }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.firstname') }}</strong> {{ submission.firstname }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.email') }}</strong> {{ submission.email }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.phone') }}</strong> {{ submission.phone }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.country') }}</strong> {{ submission.country }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormVehicle.travellers') }}</strong>
            {{ submission.specific_fields.booking.travellers }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormVehicle.start_at') }}</strong>
            {{ submission.start_date_format }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormVehicle.start_hour') }}</strong>
            {{ submission.specific_fields.booking.start_hour }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormVehicle.start_location') }}</strong>
            {{ submission.specific_fields.booking.start_location }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormVehicle.end_at') }}</strong>
            {{ submission.end_date_format }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormVehicle.end_hour') }}</strong>
            {{ submission.specific_fields.booking.end_hour }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormVehicle.end_location') }}</strong>
            {{ submission.specific_fields.booking.end_location }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormVehicle.vehicle') }}</strong>
            <ul class="pl-10">
              <li
                v-for="vehicle in submission.specific_fields.booking.vehicles"
                class="list-disc">
                {{ vehicle.name }}
              </li>
            </ul>
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormVehicle.drivers') }}</strong>
            <ul class="pl-10">
              <li
                v-for="driver in submission.specific_fields.booking.drivers"
                class="list-disc">
                {{ driver }}
              </li>
            </ul>
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormVehicle.add_sales') }}</strong>
            <ul class="pl-10">
              <li class="list-disc">
                <strong>{{ $t('account.submission.modal.quoteFormVehicle.baby_seat') }}</strong>
                {{ submission.specific_fields.addSales.baby_seat }}
              </li>
              <li class="list-disc">
                <strong>{{ $t('account.submission.modal.quoteFormVehicle.booster') }}</strong>
                {{ submission.specific_fields.addSales.booster }}
              </li>
              <li class="list-disc">
                <strong>{{ $t('account.submission.modal.quoteFormVehicle.roofRack') }}</strong>
                {{ submission.specific_fields.addSales.roofRack }}
              </li>
              <li class="list-disc">
                <strong>{{ $t('account.submission.modal.quoteFormVehicle.gearbox') }}</strong>
                {{ submission.specific_fields.addSales.gearbox }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div v-else-if="submission.type === $enums.SubmissionType.BOOK_HOTEL">
        <p>{{ $t('account.submission.modal.book_hotel.description') }}</p>
        <ul class="mt-3">
          <li>
            <strong>{{ $t('account.submission.modal.commons.lastname') }}</strong> {{ submission.lastname }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.firstname') }}</strong> {{ submission.firstname }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.email') }}</strong> {{ submission.email }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.phone') }}</strong> {{ submission.phone }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.country') }}</strong> {{ submission.country }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.book_hotel.start_at') }}</strong>
            {{ submission.start_date_format }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.book_hotel.end_at') }}</strong>
            {{ submission.end_date_format }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.book_hotel.hotel') }}</strong>
            {{ submission.host_hotel.title }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.book_hotel.status') }}</strong>
            {{ submission.specific_fields.booking.status }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.book_hotel.start_shuttle') }}</strong>
            {{ submission.specific_fields.booking.start_shuttle ? 'Oui' : 'Non' }}
          </li>
          <li v-if="submission.specific_fields.booking.start_shuttle">
            <strong>{{ $t('account.submission.modal.book_hotel.start_flight') }}</strong>
            {{ submission.specific_fields.booking.start_flight }}
          </li>
          <li v-if="submission.specific_fields.booking.start_shuttle">
            <strong>{{ $t('account.submission.modal.book_hotel.start_landing_time') }}</strong>
            {{ submission.specific_fields.booking.start_landing_time }}
          </li>

          <li>
            <strong>{{ $t('account.submission.modal.book_hotel.end_shuttle') }}</strong>
            {{ submission.specific_fields.booking.end_shuttle ? 'Oui' : 'Non' }}
          </li>
          <li v-if="submission.specific_fields.booking.end_shuttle">
            <strong>{{ $t('account.submission.modal.book_hotel.end_flight') }}</strong>
            {{ submission.specific_fields.booking.end_flight }}
          </li>
          <li v-if="submission.specific_fields.booking.end_shuttle">
            <strong>{{ $t('account.submission.modal.book_hotel.end_landing_time') }}</strong>
            {{ submission.specific_fields.booking.end_landing_time }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.book_hotel.adults') }}</strong>
            {{ submission.specific_fields.booking.adults }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.book_hotel.childs') }}</strong>
            {{ submission.specific_fields.booking.child }}
          </li>
          <li v-if="submission.specific_fields.booking.child > 0">
            <strong>{{ $t('account.submission.modal.book_hotel.year_childs') }}</strong>
            {{ submission.specific_fields.booking.year_child }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.book_hotel.rooms') }}</strong>
            {{ submission.specific_fields.booking.rooms }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.book_hotel.message') }}</strong> {{ submission.message }}
          </li>
        </ul>
      </div>
      <div v-else-if="submission.type === $enums.SubmissionType.BOOK_BRIEFING">
        <p>{{ $t('account.submission.modal.book_briefing.description') }}</p>
        <ul class="mt-3">
          <li>
            <strong>{{ $t('account.submission.modal.commons.lastname') }}</strong> {{ submission.lastname }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.firstname') }}</strong> {{ submission.firstname }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.email') }}</strong> {{ submission.email }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.phone') }}</strong> {{ submission.phone }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.country') }}</strong> {{ submission.country }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.book_briefing.briefing_date') }}</strong>
            {{ submission.briefing_date_format }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.book_briefing.adults') }}</strong>
            {{ submission.specific_fields.booking.adults }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.book_briefing.childs') }}</strong>
            {{ submission.specific_fields.booking.child }}
          </li>
          <li v-if="submission.specific_fields.booking.child > 0">
            <strong>{{ $t('account.submission.modal.book_briefing.year_childs') }}</strong>
            {{ submission.specific_fields.booking.year_child }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.book_briefing.message') }}</strong> {{ submission.message }}
          </li>
        </ul>
      </div>
      <div v-else-if="submission.type === $enums.SubmissionType.STAY">
        <p>{{ $t('account.submission.modal.quoteFormStay.description') }}</p>
        <ul class="mt-3">
          <li>
            <strong>{{ $t('account.submission.modal.commons.lastname') }}</strong> {{ submission.lastname }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.firstname') }}</strong> {{ submission.firstname }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.email') }}</strong> {{ submission.email }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.phone') }}</strong> {{ submission.phone }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.country') }}</strong> {{ submission.country }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormStay.start_at') }}</strong>
            {{ submission.start_date_format }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormStay.end_at') }}</strong>
            {{ submission.end_date_format }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormStay.shipping') }}</strong>
            {{ submission.specific_fields.booking.shipping ? 'Oui' : 'Non' }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormStay.support') }}</strong>
            {{ submission.specific_fields.booking.support ? 'Oui' : 'Non' }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormStay.adults') }}</strong>
            {{ submission.specific_fields.booking.adults }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormStay.childs') }}</strong>
            {{ submission.specific_fields.booking.child }}
          </li>
          <li v-if="submission.specific_fields.booking.child > 0">
            <strong>{{ $t('account.submission.modal.quoteFormStay.year_childs') }}</strong>
            {{ submission.specific_fields.booking.year_child }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.quoteFormStay.message') }}</strong> {{ submission.message }}
          </li>
        </ul>
      </div>
      <div v-else-if="submission.type === $enums.SubmissionType.BUY_BOOK">
        <p>{{ $t('account.submission.modal.buyBook.description') }}</p>
        <ul class="mt-3">
          <li>
            <strong>{{ $t('account.submission.modal.commons.lastname') }}</strong> {{ submission.lastname }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.firstname') }}</strong> {{ submission.firstname }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.email') }}</strong> {{ submission.email }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.phone') }}</strong> {{ submission.phone }}
          </li>
          <li>
            <strong>{{ $t('account.submission.modal.commons.country') }}</strong> {{ submission.country }}
          </li>
        </ul>
        <a
          v-if="submission.specific_fields?.link_url"
          :href="submission.specific_fields.link_url">
          <button class="btn mb-3 mr-0 w-full md:mb-0 md:mr-4 md:w-auto">
            {{ submission.specific_fields.link_label }}
          </button>
        </a>
      </div>
    </div>
  </div>
</template>
